import Elemento from "./Elemento.js";

export default class Grupo extends Elemento {
  constructor() {
    super();
    this.campos = new Array();
  }
}
